import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/app';

import './css/index.css';
import './css/discord.css';
import 'highlight.js/styles/solarized-dark.css';


ReactDOM.render(
  <App />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js